var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 25.925C8.54576 25.925 6.35196 25.0558 4.73446 23.5086C3.11695 21.9615 2.20825 19.863 2.20825 17.675C2.20825 15.487 3.11695 13.3885 4.73446 11.8414C6.35196 10.2942 8.54576 9.425 10.8333 9.425C11.3735 7.01816 12.954 4.90305 15.227 3.54498C16.3525 2.87253 17.6141 2.40617 18.9398 2.17254C20.2656 1.93891 21.6295 1.94258 22.9536 2.18333C24.2778 2.42409 25.5363 2.89722 26.6573 3.57571C27.7783 4.2542 28.7398 5.12477 29.487 6.1377C30.2341 7.15063 30.7523 8.2861 31.0119 9.47926C31.2715 10.6724 31.2674 11.8999 30.9999 13.0917H32.8333C34.5351 13.0917 36.1672 13.7677 37.3705 14.9711C38.5739 16.1744 39.2499 17.8065 39.2499 19.5083C39.2499 21.2101 38.5739 22.8422 37.3705 24.0456C36.1672 25.249 34.5351 25.925 32.8333 25.925H30.9999",
    stroke: "#9BA69C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.4248L20 14.9248L25.5 20.4248",
    stroke: "#9BA69C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.9248V31.4248",
    stroke: "#9BA69C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1a03d445aa941ffa21cd749068f9102e.svg";
export { ForwardRef as ReactComponent };